import React from 'react';
import { clsx } from 'clsx';
import {
    resolveSeverityLevel,
    scoreToSeverity,
    SEVERITY_LABELS,
    SEVERITY_STYLES,
    type SeverityLevel,
} from './intelVisualConfig';

type Props = {
    level?: SeverityLevel | string | null;
    /** Numeric risk score (0–1) — overrides `level` when provided. */
    score?: number;
    label?: string;
    className?: string;
};

export const SeverityBadge: React.FC<Props> = ({ level, score, label, className }) => {
    const resolved: SeverityLevel = score != null
        ? scoreToSeverity(score)
        : resolveSeverityLevel(typeof level === 'string' ? level : level ?? undefined);
    const styles = SEVERITY_STYLES[resolved];
    const text = label ?? SEVERITY_LABELS[resolved];

    return (
        <span
            className={clsx(
                'inline-flex items-stretch overflow-hidden rounded-md border text-[10px] font-semibold uppercase tabular-nums',
                styles.bg,
                className,
            )}
        >
            <span className={clsx('w-0.5 shrink-0', styles.bar)} aria-hidden />
            <span className={clsx('px-2 py-0.5', styles.text)}>{text}</span>
        </span>
    );
};
